import { DataStore, ItemReference, DataModel, Query, QueryResult } from 'src/core/stores/dataStore';
import { FormStore, FormModel } from 'src/core/stores/formStore';
import { repository, AsyncAction, reduce } from 'redux-scaffolding-ts';
import { container } from 'src/inversify.config';
import { Validator } from "lakmus";
import { CommandResult } from '../core/stores/types';
import { AxiosResponse } from 'axios';
import HttpService from '../core/services/http.service';
import { ProjectMemberBasicSummary, ProjectMemberSummary } from './projectmembers-store';
import { ProjectTaskBasicSummary, ProjectTaskSummary } from './projecttasks-store';

export interface ProjectTaskAssignmentSummary {
    id: number;
    plannedWorkload: number;
    employeeId: string;
    employeeTitle: string;
    projectId: string;
    projectTaskTitle: string;
    projectTaskId: string;
}

export interface ProjectTemplateTaskAssignmentSummary {
    taskIds: number;
    projectIds: number;
}

export interface ProjectTaskAssignmentTableRequestItem {
    employeeIds: string[];
    taskIds: string[];
}

export interface ProjectTaskTemplateAssignmentTableRequestItem {
    projectIds: string[];
    taskTemplateIds: string[];
}

export interface ProjectTaskAssignmentItem extends NewProjectTaskAssignmentItem {
    id: number;
}

export interface NewProjectTaskAssignmentItem {
    employeeId:  string;
    projectTaskId: string[];
    projectId: string;
    templateEmployeeId?: string[];
}

@repository("@@PROJECTTASKASSIGNMENTS", "projectTaskAssignments.summary")
export class ProjectTaskAssignmentsStore extends DataStore<ProjectTaskAssignmentSummary> {
    baseUrl: string = ``;

    constructor() {
        super('PROJECTTASKASSIGNMENT', {
            count: 0,
            isBusy: false,
            items: [],
            result: undefined,
            discard: item => { }
        }, container);
    }

    public changeUrl(companyId: string, projectId: string) {
        this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/assignments/${companyId}/${projectId}`;
    }

    public changeUrlforTable(companyId: string, projectId: string) {
        this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/assignments/${companyId}/${projectId}/table`;
    }

    public changeUrlByDeleteProjectMember(companyId: string, projectId: string) {
        this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/companies/${companyId}/projects/${projectId}/members`;
    }

    public async getAllAsync(query: Query, data?: any): Promise<QueryResult<ProjectTaskAssignmentSummary>> {
        let httpService = this.container.get<HttpService>(HttpService);
        const result = await this.dispatchAsync(this.ENTITY_LIST_UPDATE as string, httpService.get<QueryResult<ProjectTaskAssignmentSummary>>(`${this.baseUrl}?${DataStore.buildUrl(query)}`, data));
        return result.data;
    }
}

export class NewProjectTaskAssignmentValidator extends Validator<NewProjectTaskAssignmentItem> {
    constructor() {
        super();

        this.ruleFor(x => x.employeeId)
            .notNull()
            .withMessage("A valid EmployeeId is required");

        this.ruleFor(x => x.projectTaskId)
            .notNull()
            .withMessage("A valid ProjectTaskId is required");
    }
}

export class ProjectTaskAssignmentValidator extends Validator<ProjectTaskAssignmentItem> {
    constructor() {
        super();
        
        this.ruleFor(x => x.employeeId)
            .notNull()
            .withMessage("A valid EmployeeId is required");

        this.ruleFor(x => x.projectTaskId)
            .notNull()
            .withMessage("A valid ProjectTaskId is required");
    }
}

const PROJECTTASKASSIGNMENT_UPDATE_ITEM = "PROJECTTASKASSIGNMENT_UPDATE_ITEM";
@repository("@@PROJECTTASKASSIGNMENTS", "projectTaskAssignments.detail")
export class ProjectTaskAssignmentStore extends FormStore<ProjectTaskAssignmentItem> {
    baseUrl: string = ``;

    protected validate(item: ProjectTaskAssignmentItem) {
        return new ProjectTaskAssignmentValidator().validate(item);
    }

    constructor() {
        super('PROJECTTASKASSIGNMENT', {
            isBusy: false,
            status: 'New',
            item: undefined,
            result: undefined
        }, container);
        this.addReducer(PROJECTTASKASSIGNMENT_UPDATE_ITEM, (): any => {
            return super.onPatch()
        }, 'AsyncAction');
    }

    public changeUrl(companyId: string, projectId: string) {
        this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/assignments/${companyId}/${projectId}`;
    }

    public async getById(id: string, params?: any, companyId?: string): Promise<ProjectTaskAssignmentItem>  {
        var httpService = this.container.get<HttpService>(HttpService);
        const result = await this.dispatchAsync(this.ENTITY_LOAD, httpService.get<ProjectTaskAssignmentItem>(`${this.baseUrl}/${companyId}/${id}`, params));
        return result.data;
    }

    public async update(item: ProjectTaskAssignmentItem) {
        var result = await super.patch(PROJECTTASKASSIGNMENT_UPDATE_ITEM, `${item.id}`, item) as any;
        return result.data as CommandResult<ProjectTaskAssignmentItem>;
    }
}

@repository("@@PROJECTTASKASSIGNMENTS", "projectTaskAssignments.new")
export class NewProjectTaskAssignmentStore extends FormStore<NewProjectTaskAssignmentItem> {
    baseUrl: string = ``;

    protected validate(item: NewProjectTaskAssignmentItem) {
        return (new NewProjectTaskAssignmentValidator()).validate(item);
    }

    constructor() {
        super('NEW_PROJECTTASKASSIGNMENT', {
            isBusy: false,
            status: 'New',
            item: undefined,
            result: undefined
        }, container);
    }

    public changeUrl(companyId: string, projectId: string) {
        this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/assignments/${companyId}/${projectId}`;
    }

    public changeUrlProjectMember(companyId: string, projectId: string) {
        this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/companies/${companyId}/projects/newProjectMember/${projectId}`;
    }
}